import { render, staticRenderFns } from "./skillViewPrivate.vue?vue&type=template&id=0489cd54&scoped=true&"
import script from "./skillViewPrivate.vue?vue&type=script&lang=js&"
export * from "./skillViewPrivate.vue?vue&type=script&lang=js&"
import style0 from "./skillViewPrivate.vue?vue&type=style&index=0&id=0489cd54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489cd54",
  null
  
)

export default component.exports